import { Map, Record } from '@gonfalon/immutable-shim/immutableShim';

import type { RepoStats } from '#utils/codeRefs/types';

export class CodeStatisticsForFlag extends Record<RepoStats>({
  _links: Map(),
  name: '',
  sourceLink: '',
  defaultBranch: '',
  enabled: false,
  version: 0,
  hunkCount: 0,
  fileCount: 0,
}) {
  getCodeReferenceCount() {
    return this.hunkCount;
  }
}
